import ProductImagesModal from './ProductImagesModal';

export default ProductImagesModal; 